import * as service from "@/services/retreats-service";
import { useEffect, useState } from "react";
import Spinner from "@/components/spinner";
import { toast } from "react-toastify";
import ISeason from "@/models/seasons/iseason";
import { useModal } from "@/components/modals/templating/modal";
import AddRetreat from "./add";
import ViewCardRetreat from "./view-card";
import { useNavigate } from "react-router";
import { getRetreatShowPreference, setRetreatShowPreference } from "@/common/user-preferences";

const ViewAllRetreats: React.FC = () => {
    const [isLoading, setIsLoading ] = useState<boolean>(true);
    const [seasons, setSeasons ] = useState<ISeason[]>();
    const [showAllRetreats, setShowAllRetreats] = useState<boolean>(getRetreatShowPreference());

    const AddModal = useModal(<AddRetreat closeModal={(requiresUpdate: boolean) => closeAddRetreatModal(requiresUpdate)}/>);
    
    const navigate = useNavigate();

    async function updateData(){
        try {
            const response = await service.getRetreats(getRetreatShowPreference());

            setSeasons(response);
        } catch (e) {
            const error = e as Error;
            
            toast.error(error.message);

            if (error.message.includes("Unauthorised")) {
                navigate("/login");
            }
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await updateData();

            setIsLoading(false);
        }

        fetchData();
    }, [])

    function closeAddRetreatModal(requiresUpdate: boolean) {
        AddModal.closeModal();

        if (requiresUpdate) {
            updateData();
        }
    }

    function updateRetreatShowPreference() {
        setRetreatShowPreference(!getRetreatShowPreference());
        setShowAllRetreats(getRetreatShowPreference());
        
        updateData();
    }
    
    return (
        <Spinner isLoading={isLoading}>
            <div className="retreats">
                <h1 className="mt-3 text-6xl font-thin text-center">Retreats</h1>
                <div>
                    <button className="float-right px-3 py-1 mx-3 mb-2 bg-br-green hover:brightness-110" onClick={updateRetreatShowPreference}>
                        {showAllRetreats ? (
                            <i className="fas fa-eye-slash" title="Hide previous retreats" />
                        ):(
                            <i className="fas fa-eye" title="Show previous retreats"/>
                        )}
                    </button>
                    <button className="float-right px-3 py-1 mx-3 mb-2 bg-br-green hover:brightness-110" onClick={() => AddModal.openModal()}>Add a new retreat</button>
                    {AddModal.modalOpen && <AddModal.ModalContent />}
                </div>
                <div className="clear-both">
                    {seasons?.map(s => (
                        <div key={s.id}>
                            {s.retreats.length > 0 && 
                                <div>
                                    <h1 className="lg:text-3xl md:text-2xl text-xl mt-4 mb-3 px-5">
                                        <span>
                                            {s.name} ({s.retreats.length})
                                        </span>
                                    </h1>
                                    <hr className="mb-4" />

                                    <div className="flex flex-wrap justify-around mb-6">
                                        {s.retreats?.map(r => (
                                            <ViewCardRetreat key={r.id} retreat={r} />
                                        ))}
                                    </div>
                                </div>
                            }

                        </div>
                    ))}
                </div>
            </div>
        </Spinner>
        
    )
}

export default ViewAllRetreats;